// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__T8H4E","LoupeSvg":"Image_LoupeSvg__2BN7N","Hover":"Image_Hover__3HaN5"};